import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllFederalReligiousData,
  fetchDefaultFederalList,
  fetchUpdateDeletFederalList,
} from "../../../store/PracticeInfo/FederalReligiousActions";
import "./FederalReligious.scss";
import PopupModal from "../../../common/PopupModal";
import CgFormCreator from "../../../common/CgFormCreator";
import { useLocation } from "react-router-dom";

const FederalReligious = () => {
  const [defaultFederal, setDefaultFederal] = useState([]);
  const [defaultRelijious, setDefaultReligious] = useState([]);
  const [confirmDeleteMap, setConfirmDeleteMap] = useState({});
  const [isOpen, setOpen] = useState(false);
  const [federalHolidaysList, setFederalHolidaysList] = useState([]);
  const [religiousHolidaysList, setReligiousHolidaysList] = useState([]);

  const [federalDefaultValues, setFederalDefaultValues] = useState([]);
  const [religiousDefaultValues, setReligiousDefaultValues] = useState([]);

  const [federalSelectAll, setFederalSelectAll] = useState(false);
  const [religiousAll, setReligiousAll] = useState(false);
  const [showError, setShowError] = useState(false);

  const location = useLocation();
  const locationHeaderData = location.pathname.split("/");
  const practiceId = locationHeaderData[2];

  const dispatch = useDispatch();

  const {
    practiceAllFederalList,
    isFederalError,
    isPracticeAllFederalListLoading,
  } = useSelector((state) => state.allListFederalReligious);
  const {
    federaReligiouslDefaultValues,
    federalDefaultError,
    isFederalReligiousLoading,
  } = useSelector((state) => state.defaultFederalReligious);

  const federalData = [];
  const religiousData = [];
  useEffect(() => {
    dispatch(fetchAllFederalReligiousData());
    dispatch(fetchDefaultFederalList(practiceId));
  }, []);

  useEffect(() => {
    if (isFederalError || federalDefaultError) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [isFederalError, federalDefaultError]);

  useEffect(() => {
    const federal = federaReligiouslDefaultValues?.filter(
      (item) => item.type === "FEDERAL"
    );
    const religious = federaReligiouslDefaultValues?.filter(
      (item) => item.type === "RELIGIOUS"
    );
    setDefaultFederal(federal);
    setDefaultReligious(religious);
  }, [federaReligiouslDefaultValues]);

  useEffect(() => {
    practiceAllFederalList?.filter((item) => {
      if (item.type === "FEDERAL") {
        federalData.push(item);
      } else {
        religiousData.push(item);
      }
    });
    setFederalHolidaysList(federalData);
    setReligiousHolidaysList(religiousData);
  }, [practiceAllFederalList]);

  useEffect(() => {
    const result = defaultFederal?.map((item) => item.code);
    setFederalDefaultValues(result);
  }, [defaultFederal]);

  useEffect(() => {
    const result = defaultRelijious?.map((item) => item.code);
    setReligiousDefaultValues(result);
  }, [defaultRelijious]);

  const handleUpdateHolidaysList = (val) => {
    const { federalHolidays, religiousHolidays } = val;
    const updateArray = [...federalHolidays, ...religiousHolidays];
    const result = practiceAllFederalList.filter((item) =>
      updateArray.includes(item.code)
    );
    const updatedArray = result?.map((item) => {
      return item.code;
    });
    const payload = {
      holidays: updatedArray,
    };

    dispatch(fetchUpdateDeletFederalList({ practiceId, data: payload })).then(
      () => {
        dispatch(fetchDefaultFederalList(practiceId));
      }
    );
    setOpen(!isOpen);
  };

  const toggleConfirmDelete = (code, value) => {
    setConfirmDeleteMap((prev) => ({
      ...prev,
      [code]: value,
    }));
  };

  const deleteAPiCall = (code) => {
    const result = federaReligiouslDefaultValues?.filter(
      (item) => item.code !== code
    );
    const updatedArray = result?.map((item) => {
      return item.code;
    });
    const payload = {
      holidays: updatedArray,
    };
    dispatch(fetchUpdateDeletFederalList({ practiceId, data: payload })).then(
      () => {
        dispatch(fetchDefaultFederalList(practiceId));
      }
    );
    // const updatedValues = {
    //   practiceHolidayDTO: result,
    // };
    // dispatch(updateDefaultHolidayDetails(updatedValues));
  };

  const getSelectAllDefaultValuesFederal = (data, filter) => {
    if (filter !== "none") {
      const result = federalHolidaysList.map((item) => item.code);
      setFederalDefaultValues(result);
    } else {
      setFederalDefaultValues([]);
    }
  };
  const getSelectAllDefaultValuesReligious = (data, filter) => {
    if (filter !== "none") {
      const result = religiousHolidaysList.map((item) => item.code);
      setReligiousDefaultValues(result);
    } else {
      setReligiousDefaultValues([]);
    }
  };

  const RenderFederalReligiousAddBtn = (header) => {
    return (
      <div className="holidayHeaderWrapper">
        <div className="holidayHeader">{header}</div>
        <a
          className="btn-license edit-button-license"
          onClick={() => {
            setOpen(!isOpen);
            setConfirmDeleteMap({});
          }}
        >
          + ADD
        </a>
      </div>
    );
  };

  const RenderFederalHolidaysList = () => {
    return (
      <div className="contentWrapper">
        <div>{RenderFederalReligiousAddBtn("Federal Holidays")}</div>
        {federaReligiouslDefaultValues?.length < 1 && (
          <div className="noDataFound">No holidays data for this practice</div>
        )}
        <div className="holidayListItem">
          {defaultFederal?.map((item) => {
            return (
              <div className="g-col-6 languages-info" key={item.code}>
                {item.name}
                <div>
                  {confirmDeleteMap[item.code] && (
                    <button
                      type="button"
                      className="btn border-0 canceldelete"
                      onClick={() =>
                        toggleConfirmDelete(item.code, false, defaultFederal)
                      }
                    >
                      CANCEL
                    </button>
                  )}
                  <button
                    type="button"
                    className={`btn ${
                      confirmDeleteMap[item.code]
                        ? "deleteConfirmation"
                        : "border-0 delete-button"
                    }`}
                    onClick={() => {
                      if (confirmDeleteMap[item.code]) {
                        deleteAPiCall(item.code, defaultFederal);
                      } else {
                        toggleConfirmDelete(item.code, true, defaultFederal);
                      }
                    }}
                  >
                    {confirmDeleteMap[item.code] ? "CONFIRM" : "DELETE"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const RenderReligiousHolidaysList = () => {
    if (isFederalReligiousLoading) return <div> Loading ...</div>;
    return (
      <div className="contentWrapper">
        <div>
          {federaReligiouslDefaultValues?.length > 0 &&
            RenderFederalReligiousAddBtn("Religious Holidays")}
        </div>
        <div className="holidayListItem">
          {defaultRelijious?.map((item) => {
            return (
              <div className="g-col-6 languages-info" key={item.code}>
                {item.name}
                <div>
                  {confirmDeleteMap[item.code] && (
                    <button
                      type="button"
                      className="btn border-0 canceldelete"
                      onClick={() =>
                        toggleConfirmDelete(item.code, false, defaultFederal)
                      }
                    >
                      CANCEL
                    </button>
                  )}
                  <button
                    type="button"
                    className={`btn ${
                      confirmDeleteMap[item.code]
                        ? "deleteConfirmation"
                        : "border-0 delete-button"
                    }`}
                    onClick={() => {
                      if (confirmDeleteMap[item.code]) {
                        deleteAPiCall(item.code, defaultFederal);
                      } else {
                        toggleConfirmDelete(item.code, true, defaultFederal);
                      }
                    }}
                  >
                    {confirmDeleteMap[item.code] ? "CONFIRM" : "DELETE"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const RenderReligiousFederalHolidaysPopup = () => {
    if (isPracticeAllFederalListLoading) return null;

    const RenderHolidaysPopup = () => {
      const holidaysListSchema = [
        {
          component: "checkbox",
          options: federalHolidaysList,
          shouldRenderCheckboxWithBackgroundImageStyle: true,
          keyValues: { label: "name", value: "code" },
          onSelect: () => {},
          defaultValues: federalDefaultValues,
          name: "federalHolidays",
          onChangeCheckbox: (updatedValues) => {
            setFederalSelectAll(
              federalHolidaysList?.length === updatedValues?.length
            );
          },
          customRenderLabel: () => {
            return (
              <div className="popup-checkbox-subheading">
                <div className="holidaysHeader">
                  <div className="holidayHeaderText">FEDERAL</div>
                  {!federalSelectAll && (
                    <div
                      className="selectAllBtn"
                      onClick={() => {
                        setFederalSelectAll(!federalSelectAll);
                        getSelectAllDefaultValuesFederal(federalHolidaysList);
                      }}
                    >
                      Select All
                    </div>
                  )}
                  {federalSelectAll && (
                    <div
                      className="selectAllBtn"
                      onClick={() => {
                        setFederalSelectAll(!federalSelectAll);
                        getSelectAllDefaultValuesFederal(
                          federalHolidaysList,
                          "none"
                        );
                      }}
                    >
                      Unselect All
                    </div>
                  )}
                </div>
              </div>
            );
          },
        },
        {
          component: "checkbox",
          options: religiousHolidaysList,
          shouldRenderCheckboxWithBackgroundImageStyle:true,
          keyValues: { label: "name", value: "code" },
          onSelect: () => {},
          defaultValues: religiousDefaultValues,
          name: "religiousHolidays",
          onChangeCheckbox: (updatedValues) => {
            setReligiousAll(
              religiousHolidaysList?.length === updatedValues?.length
            );
          },
          customRenderLabel: () => {
            return (
              <div className="popup-checkbox-subheading">
                <div className="holidaysHeader">
                  <div className="holidayHeaderText">RELIGIOUS/CULTURAL</div>
                  {!religiousAll && (
                    <div
                      className="selectAllBtn"
                      onClick={() => {
                        setReligiousAll(!religiousAll);
                        getSelectAllDefaultValuesReligious(
                          religiousHolidaysList
                        );
                      }}
                    >
                      Select All
                    </div>
                  )}
                  {religiousAll && (
                    <div
                      className="selectAllBtn"
                      onClick={() => {
                        setReligiousAll(!religiousAll);
                        getSelectAllDefaultValuesReligious(
                          religiousHolidaysList,
                          "none"
                        );
                      }}
                    >
                      Unselect All
                    </div>
                  )}
                </div>
              </div>
            );
          },
        },
      ];
      return (
        <div className="popupFormContent">
          <div>
            <div className="federalPopupHeader">Observed Holidays</div>
            <div className="federalPopupDesc">
              Please indicate all the holidays your office is closed
            </div>
          </div>
          <div className="federalFormWrapper">
            <CgFormCreator
              key={`${federalDefaultValues.join(',')}-${religiousDefaultValues.join(',')}`}
              primaryButton="Save"
              schema={holidaysListSchema}
              onSubmitCallback={(val) => {
                handleUpdateHolidaysList(val);
              }}
              onCancel={() => {
                dispatch(fetchDefaultFederalList(practiceId));
                setFederalSelectAll(!federalSelectAll);
                setReligiousAll(!religiousAll);
                setOpen(!isOpen);
              }}
            />
          </div>
        </div>
      );
    };
    return (
      <div>
        <PopupModal
          isOpen={isOpen}
          customRender={RenderHolidaysPopup}
          onClose={() => {
            dispatch(fetchDefaultFederalList(practiceId));
            setFederalSelectAll(!federalSelectAll);
            setReligiousAll(!religiousAll);
            setOpen(!isOpen);
          }}
        />
      </div>
    );
  };

  const RenderErorMsg = () => {
    if (!showError) return null;
    return (
      <div className="alert alert-danger" role="alert">
        Something went wrong. Please check and try again
      </div>
    );
  };

  return (
    <div className="holidayListWrappers">
      <div className="federalReligiousHeading">Observed Holidays</div>
      {RenderErorMsg()}
      {RenderFederalHolidaysList()}
      {RenderReligiousHolidaysList()}
      {RenderReligiousFederalHolidaysPopup()}
    </div>
  );
};

export default FederalReligious;
